<template>
  <div class="box-border has-background-white h-100-per">
    <div class="mg-b-7 line-title-dh is-flex is-justify-spacebetween">
      <b-tooltip
        label="Move"
        type="is-dark"
        v-if="user.userLevel == 0"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("dashboard.mainDashboardInvestment") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("dashboard.mainDashboardInvestment") }}
      </p>
      <p
        class="pd-y-10 icon-color is-size-5 cr-pointer"
        @click="$emit('openModalInfo', 'im')"
      >
        <i class="fas fa-question-circle"></i>
      </p>
    </div>
    <div
      v-if="taskApproveAmount !== 0 || taskPendingRequest !== 0"
      class="pd-y-10 pd-20 mg-t-25"
    >
      <div class="has-text-centered">
        <Doughnut
          v-if="taskApproveAmount !== 0 || taskPendingRequest !== 0"
          :width="220"
          :height="220"
          :labels="['Approved Amount', 'Pending']"
          :bgColor="['#00a79d', '#c7c7c7']"
          :numData="[taskApproveAmount, taskPendingRequest]"
          :tooltipsOpen="true"
        />
        <Doughnut
          v-else
          :width="220"
          :height="220"
          :labels="['Approved Amount', 'Pending']"
          :bgColor="['#00a79d', '#c7c7c7']"
          :numData="[0, -1]"
        />
      </div>
      <div class="mg-t-20 pd-20 has-text-centered">
        <p
          class="is-size-5 has-text-weight-normal has-text-dark is-flex is-align-center pd-5 is-justify-center"
        >
          <b-icon
            pack="fas"
            icon="circle"
            size="is-small"
            class="done-color"
          ></b-icon>
          {{ $t("staffList.investmentSupportApproved") }}:
          <span title="Show at company" class="hoverApprove pd-l-5"
            >฿{{ taskApproveAmount | comma }}
          </span>
          <span
            v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
            title="Full approved investment"
            class="hoverApprove"
            ><span class="pd-Approve"> / </span>฿{{
              taskApproveAmountStaffAdmin | comma
            }}</span
          >
        </p>
        <p
          class="is-size-5 has-text-weight-normal has-text-dark is-flex is-align-center pd-5 is-justify-center"
        >
          <b-icon
            pack="fas"
            icon="circle"
            size="is-small"
            class="pending-color"
          ></b-icon>
          {{ $t("staffList.investmentSupportPending") }}:
          <span title="Show at company" class="pd-l-5"
            >฿{{ taskPendingRequest | comma }}
          </span>
          <span
            v-if="getRule !== 'startup' && typeof showCompany !== 'undefined'"
            title="Full Pending investment"
            ><span class="pd-Approve"> / </span>฿{{
              taskPendingRequestStaffAdmin | comma
            }}</span
          >
        </p>
      </div>
    </div>
    <div
      v-else
      class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
    >
      <p>*** {{ $t("dashboard.notfound") }} ***</p>
    </div>
  </div>
</template>

<script>
import Doughnut from "@/charts/Doughnut";
export default {
  components: {
    Doughnut,
  },
  data() {
    return {
      render: false,
    };
  },
  props: ["useBy", "tasksAllStartup", "showCompany"],
  computed: {
    user() {
      return this.$store.state.user;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
    taskPendingRequest() {
      if (this.useBy === "startup") {
        return this.taskPendingRequestInVisible;
        this.render = true;
      } else {
        return this.taskPendingRequestStaffAdmin;
        this.render = true;
      }
    },
    taskApproveAmount() {
      if (this.useBy === "startup") {
        return this.taskApproveAmountInVisible;
      } else {
        return this.taskApproveAmountStaffAdmin;
      }
    },
    taskPendingRequestStaffAdmin() {
      let amount = 0;
      let tasks =
        typeof this.tasksAllStartup !== "undefined"
          ? this.tasksAllStartup
          : this.$store.getters.tasks;
      tasks.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus !== 5 &&
          item.fundStatus !== 0 &&
          item.fundStatus !== 1
        ) {
          amount = amount + item.fundAmount;
        }
      });
      return amount;
    },
    taskPendingRequestInVisible() {
      let amount = 0;
      this.$store.getters.taskInVisible.map((item) => {
        if (
          item.fundAmount !== null &&
          typeof item.fundAmount !== "undefined" &&
          item.fundAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus !== 5 &&
          item.fundStatus !== 0 &&
          item.fundStatus !== 1
        ) {
          amount = amount + item.fundAmount;
        }
      });

      return amount;
    },
    taskApproveAmountStaffAdmin() {
      let amount = 0;
      let tasks =
        typeof this.tasksAllStartup !== "undefined"
          ? this.tasksAllStartup
          : this.$store.getters.tasks;
      tasks.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus === 5
        ) {
          amount = amount + item.approveAmount;
        }
      });
      return amount;
    },
    taskApproveAmountInVisible() {
      let amount = 0;
      this.$store.getters.taskInVisible.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== "" &&
          item.fundStatus !== 4 &&
          item.fundStatus === 5
        ) {
          amount = amount + item.approveAmount;
        }
      });
      //console.log('amount',amount)
      return amount;
    },
  },
};
</script>
<style scoped>
.done-color {
  color: #00a79d;
}
.pending-color {
  color: #c7c7c7;
}
</style>